export default "__VITE_ASSET__a7d59e60__"